// Pre-cloud local data (read-only helpers used by the one-time cloud migration).

export interface LegacyUser {
  username: string;
  passHash: string;
  role: "admin" | "user";
  createdAt: number;
}

// Users that existed when accounts lived in this browser.
export function loadLegacyUsers(): LegacyUser[] {
  try {
    const arr = JSON.parse(localStorage.getItem("mytv.users") || "[]");
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

// Every mytv.u.<username>.<key> value for one user (their local app data).
export function legacyUserData(username: string): Record<string, string> {
  const prefix = `mytv.u.${username}.`;
  const out: Record<string, string> = {};
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && k.startsWith(prefix) && !k.endsWith(".__cloudDirty")) out[k.slice(prefix.length)] = localStorage.getItem(k) ?? "";
  }
  return out;
}

// Older still: data from before per-user namespacing → move into the first admin's space.
export function migrateLegacyData() {
  const admin = loadLegacyUsers().find((u) => u.role === "admin");
  const prefix = `mytv.u.${admin ? admin.username : "rhythm"}.`;
  mergeArrayById("mytv.replay.sessions", prefix + "replay.sessions");
  const drawingKeys: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && k.startsWith("mytv.drawings.")) drawingKeys.push(k);
  }
  for (const k of drawingKeys) mergeArrayById(k, prefix + k.slice("mytv.".length));
  const legacyState = localStorage.getItem("mytv.state");
  if (legacyState != null) {
    if (localStorage.getItem(prefix + "state") === null) localStorage.setItem(prefix + "state", legacyState);
    localStorage.removeItem("mytv.state");
  }
}

function mergeArrayById(legacyKey: string, targetKey: string) {
  const raw = localStorage.getItem(legacyKey);
  if (raw == null) return;
  const parse = (s: string | null): any[] => {
    try {
      const a = JSON.parse(s || "[]");
      return Array.isArray(a) ? a : [];
    } catch {
      return [];
    }
  };
  const cur = parse(localStorage.getItem(targetKey));
  const ids = new Set(cur.map((x) => x?.id));
  for (const item of parse(raw)) if (item && !ids.has(item.id)) cur.push(item);
  localStorage.setItem(targetKey, JSON.stringify(cur));
  localStorage.removeItem(legacyKey);
}
